import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import BeforeAfter from "@/components/site/BeforeAfter";
import Projects from "@/components/site/Projects";
import Process from "@/components/site/Process";
import Stats from "@/components/site/Stats";
import Testimonials from "@/components/site/Testimonials";
import QuoteForm from "@/components/site/QuoteForm";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import BlogTeaser from "@/components/site/BlogTeaser";
import Marquee from "@/components/site/Marquee";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Manifesto />
      <Stats />
      <Services />
      <BeforeAfter />
      <Projects />
      <Marquee />
      <Process />
      <Testimonials />
      <QuoteForm />
      <BlogTeaser />
      <FAQ />
      <Contact />
    </div>
  );
}
